import React from 'react';
import Subtitles from '../../containers/Subtitles';

function PrivateHome (){

    return <Subtitles/>;
}

export default PrivateHome;



// WEBPACK FOOTER //
// ./src/components/PrivateHome/index.js